<template>
  <div class="productView container">
    <product-d32 v-if="categoryId === '137'"/>
    <product-d26 v-if="categoryId === '138'"/>
    <product-e26 v-if="categoryId === '146'"/>
  </div>
</template>

<script>
import productD32 from './detail/productD32.vue'
import productE26 from './detail/productE26.vue'
import productD26 from './detail/productD26.vue'

export default {
  name: 'productDetail',
  data () {
    return {
      categoryId: 0
    }
  },
  computed: {},
  mounted: function (s) {
    // 取到路由带过来的参数
    let obj = this.$route.query
    // 将数据放在当前组件的数据内
    if (obj.categoryId) {
      this.categoryId = obj.categoryId
      localStorage.product_categoryId = obj.categoryId
    } else if (localStorage.product_categoryId) {
      this.categoryId = localStorage.product_categoryId
    }
  },
  methods: {
  },
  filters: {
  },
  components: {
    productD32,
    productD26,
    productE26
  },
  watch: {
  }
}

</script>

<style scoped>
.productView {
  margin-top: 50px;
  width: 100%;
  border-top: 1px solid #F0F0F0;
  border-bottom: 1px solid #e8e8e8;
}
</style>



// WEBPACK FOOTER //
// src/components/product/productDetail.vue